import './ConfigAssistant.css';

import { ConfigWizard } from './ConfigAssistantSteps/ConfigWizard';
import { useNavigate } from 'react-router-dom';
import CheckList from './ConfigAssistantSteps/Checklist/CheckList';
import { FitConnect } from './ConfigAssistantSteps/Fitconnect/FitConnect';
import DestinationRenaming from './ConfigAssistantSteps/Destinations/DestinationRenaming';
import DestinationKeyUpload from './ConfigAssistantSteps/Destinations/DestinationKeyUpload';
import DataModel from '../../pages/Settings/SettingsTabs/Datamodels/DataModel';
import SenderConfiguration from './ConfigAssistantSteps/SenderConfiguration/SenderConfiguration';
import BundId from './ConfigAssistantSteps/BundId/BundId';
import Logo from './ConfigAssistantSteps/Logo/Logo';
import FooterLinks from './ConfigAssistantSteps/FooterLinks/FooterLinks';
import Summary from './ConfigAssistantSteps/Summary/Summary';
import useConfigurationStep, {
  ConfigurationStep,
  ConfigurationStepDto
} from '../../api/hooks/useConfigurationStep';
import { getIndexOfConfigurationStep } from './ConfigWizard.helper';
import { RoutePaths } from '../AppRoutes';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BehApiRoutes, behClient } from '../../api/beh-api';
import { useTranslation } from 'react-i18next';

export function ConfigAssistantPage() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { configurationStep } = useConfigurationStep();
  const navigate = useNavigate();
  const { mutateAsync: updateConfigurationStep } = useMutation({
    mutationFn: ({ payload }: { payload: ConfigurationStepDto }) =>
      behClient.patch(BehApiRoutes.configurationStep(), payload)
  });

  return (
    <div className="container">
      <ConfigWizard
        abortButtonLabel="Abbrechen"
        confirmButtonLabel={t('configAssistent.summary.primaryButton')}
        defaultHeading={t('configAssistent.header.title')}
        defaultPageUpButtonLabel="Weiter"
        defaultPageDownButtonLabel="Zurück"
        size="l"
        closeOnBackdropClick={false}
        onConfirmed={() => {
          updateConfigurationStep({
            payload: {
              configurationStep: ConfigurationStep.FINISH
            }
          }).then(() => {
            queryClient.setQueryData([BehApiRoutes.configurationStep()], {
              configurationStep: ConfigurationStep.FINISH
            });
            navigate(RoutePaths.ANTRAEGE);
          });
        }}
        isOpen
        startOnPageIndex={getIndexOfConfigurationStep(
          configurationStep?.configurationStep
        )}
      >
        <CheckList key="checklist" />
        <FitConnect key="fitconnect" />
        <DestinationRenaming key="destinationsRenaming" />
        <DestinationKeyUpload key="destinationsKeyUpload" />
        <DataModel key="datamodel" />
        <SenderConfiguration key="senderconfiguration" />
        <BundId key="bundid" />
        <Logo key="logo" />
        <FooterLinks key="footerlinks" />
        <Summary key="summary" />
      </ConfigWizard>
    </div>
  );
}
